import { createFileRoute } from '@tanstack/react-router';
import { CompanyDocuments } from '@/components/company/documents/company-documents';

export const Route = createFileRoute('/(app)/company/documents')({
  component: DocumentsPage,
});

function DocumentsPage() {
  return <CompanyDocuments />;
}

